import { initialState } from "../../redux/modules/newNotifications";

export function buildExclusiveCheckboxFilters(selectedTypes = []) {
  const selected = new Set(selectedTypes);
  const filters = {};

  for (const [name, filter] of Object.entries(initialState.filters)) {
    if (filter.type !== "checkbox") {
      continue;
    }

    filters[name] = selected.has(name);
  }

  return filters;
}
